import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ConfirmEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState("Verifying email...");

  useEffect(() => {
    const confirmEmail = async () => {
      const token = new URLSearchParams(location.search).get("token");
      if (!token) {
        setStatus("Missing token.");
        setTimeout(() => navigate("/login"), 3000);
        return;
      }

      try {
        const response = await fetch(
          `https://bookmatchup.onrender.com/api/auth/confirm-email?token=${token}`
        );
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Email confirmation failed");
        }

        setStatus(data.message || "Email confirmed successfully!");
        setTimeout(() => navigate("/login"), 3000);
      } catch (error) {
        console.error("Error confirming email:", error);
        setStatus(error.message || "Something went wrong.");
        setTimeout(() => navigate("/login"), 3000);
      }
    };

    confirmEmail();
  }, [location.search, navigate]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h2>{status}</h2>
      <p>Redirecting to login...</p>
    </div>
  );
};

export default ConfirmEmail;
